import {AfterViewInit, ChangeDetectorRef, Component, ElementRef} from '@angular/core';

// import SwaggerUI from 'swagger-ui';
// import { SwaggerUIBundle, SwaggerUIStandalonePreset } from "swagger-ui-dist"
// import SwaggerClient from 'swagger-client';
import { HttpClient } from '@angular/common/http';
import {environment} from 'projects/app-ui/src/environments/environment';
import {CSRFService} from '../service/csrf.service';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {ActivatedRoute} from '@angular/router';


interface Url {
    name: string;
    url: string;
}

@Component({
    selector: 'dmp-swagger',
    templateUrl: './swagger.component.html',
    styleUrls: ['./swagger.component.scss'],
    standalone: false
})
export class SwaggerComponent implements AfterViewInit {

    private validatorUrl: any;
    private ui: any;
    selectedUrl: Url;
    urls: Url[] = [];

    prod: boolean = environment.production;

    iframeSrc: SafeResourceUrl = null;

    constructor(private el: ElementRef,
                private httpClient: HttpClient,
                private ref: ChangeDetectorRef,
                private CSRFService: CSRFService,
                private route: ActivatedRoute,
                private sanitizer: DomSanitizer) {
    }

    ngAfterViewInit() {
        this.httpClient.get('/swagger-resources/configuration/ui').subscribe(data => {
            // this.validatorUrl = data.validatorUrl;
        });

        //
        let doc = null;
        let endpoint = null;
        this.route.queryParams
            .subscribe(params => {
                if (params.doc) {
                    doc = params.doc;
                }
                if (params.endpoint) { // &endpoint=Engine32Data32Query
                    endpoint = params.endpoint;
                }
            });

        let urlIframe = `swagger-ui/index.html`; // ?csrf=${this.getCSRF()}
        if (doc) {
            urlIframe += `&doc=${doc}`;
        }
        if (endpoint) {
            urlIframe += `#!/${endpoint}`;
        }
        this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(urlIframe);
        // this.initialize();
    }

  private initializeSpringfox() {
    let security = {};

    this.httpClient.get('/swagger-resources/configuration/security').subscribe(data => {
        security = data;
        security = {
            realm: 'http://uaa:9999/oauth/token',
            appName: 'uaa',
            clientId: 'internal',
            clientSecret: 'internal'
        };
        if (this.oAuthIsDefined(security)) {
            this.ui.initOAuth(security);
        } else {
            // this.ui.preauthorizeBasic("basicAuth", "admin", "admin");
        }
    });
  }

  private oAuthIsDefined(security) {
    return security.clientId
      && security.clientSecret
      && security.appName
      && security.realm;
  }

  private getCSRF() {
    return this.CSRFService.getCSRF();
  }

  change(event) {
    this.ui.headerView.trigger('update-swagger-ui', {
      url: this.selectedUrl.url
    });
  }

}
